export default __webpack_public_path__ + "static/media/treasure-box.44719cd9.svg";